<template>
    <div>
        <el-card shadow="never">
			<div>
				<el-form
					size="small"
					:inline="true"
					label-position="right"
					label-width="100px"
					:rules="rules"
					:model="formData"
				>
					<el-form-item label="缴费金额(元)">
						<el-input
							v-model="formData.payAmount"
							:disabled="true"
							:readonly="true"
						></el-input>
					</el-form-item>
					<el-form-item label="预存金额(元)">
						<el-input
							v-model="formData.payReAmount"
							:disabled="true"
                            :readonly="true"
						></el-input>
					</el-form-item>
					<el-form-item label="退款原因" prop="refundReason">
						<el-input
							size="small"
							type="textarea"
							v-model="formData.refundReason"
							:autosize="{ minRows: 2, maxRows: 4 }"
							placeholder="请输入退款原因"
                            
							clearable
						></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="form-buttons-center">
				<el-button size="small" type="primary" :loading="saveLoading" @click="doSaveForm">退款</el-button>
				<el-button size="small" @click="doClose">关闭</el-button>
			</div>
		</el-card>
    </div>
</template>
<script>
import dlgForm from "@/mixin/dlgForm";
import { pick } from "lodash";
export default {
	name: "OfflineRefundForm",
	mixins: [dlgForm],
	data() {
		return {
			rules: {
				refundReason: [{ required: true, message: "请输入退款原因", trigger: "blur" }],
			},
		};
	},
	methods: {
        getFormData() {
            const formData = pick(this.formData, ['id', 'refundReason']);
            return formData;
        },
		doSaveForm() {
            const url = "meter/web/order/offlineRefund";
            this._doSaveForm(this.$refs.form, url, 'POST');
		}
	}
};
</script>
<style scoped>
.el-input-number::v-deep .el-input__inner {
	text-align: left;
}
</style>